<template>
  <v-container class="pa-0 mt-2">
    <v-row class="ma-0">
      <v-col cols="12" sm="6" md="2" class="px-3 py-0">
        <label>Periodo</label>
        <v-menu
          ref="dtI"
          v-model="dtI"
          :close-on-content-click="true"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateIFormatted"
              dense
              v-mask="'##/####'"
              format="MM/YYYY"
              placeholder="Período MM/YYYY"
              label
              outlined
              v-bind="attrs"
              v-on="on"
              append-icon="mdi-calendar-blank"
              @blur="dateI = parseDate(dateIFormatted)"
            ></v-text-field>
          </template>
          <v-date-picker color="primary" 
            type="month"
            v-model="dateI"
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="px-0 pr-5 py-0">
            <label>Operadoras</label>
            <v-autocomplete
              v-model="formData.operadoras"
              :items="operadoras"
              item-value="id"
              item-text="oper_nome"
              label="Selecione"
              multiple
              chips
              outlined
              flat
              solo
              dense
              filled
              :disabled="formData.carteira_id!=null || operadoras.length==1"
            >
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleAllPrestadores('operadoras', 'operadoras', 'isAllOperadorasSelected')">
              <v-list-item-content>
                <v-list-item-title>{{isAllOperadorasSelected? 'NENHUM' : 'TODOS' }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
          <template v-slot:item="data">
            <v-list-item @click="toggleAutocomplete(data.item, 'operadoras')" :class="formData.operadoras.includes(data.item.id)? 'primary--text v-list-item--active': ''">
              <v-list-item-content>
                <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 2" small label class="ma-1" :style="formData.operadoras.length>1? 'max-width:28%':'max-width:90%'">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 2" class="ml-2 grey--text caption">
              (+{{
                formData.operadoras.length == 3
                  ? formData.operadoras.length - 2 + " outro"
                  : formData.operadoras.length - 2 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col>




      <!-- <v-col cols="12" sm="6" md="8" class="px-3 py-0">
        <label>Operadoras</label>

        <v-autocomplete
          v-model="formData.operadoras"
          :items="operadoras"
          item-value="id"
          item-text="oper_nome"
          Placeholder="Selecione"
          multiple
          chips
          outlined
          flat
          solo
          dense
          filled
          :search-input.sync="searchInput"
        >
          <template v-slot:item="data">
        <v-list-item @click="toggleOperadora(data.item)">
          <v-list-item-content>
            <v-list-item-title>{{data.item.oper_nome}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
    </template>
          <template v-slot:selection="data">
            <v-chip v-if="data.index < 5" small label class="ma-1">{{
              data.item.oper_nome
            }}</v-chip>
            <span v-if="data.index == 5" class="ml-2 grey--text caption">
              (+{{
                formData.operadora.length == 6
                  ? formData.operadora.length - 5 + " outro"
                  : formData.operadora.length - 5 + " outros"
              }})
            </span>
          </template>
        </v-autocomplete>
      </v-col> -->
      <v-col class="mt-2 px-3" cols="12" sm="6" md="2">
        <v-btn
          v-if="showLine === false"
          height="30px"
          small
          max-width="100%"
          style="padding: 0 10px"
          depressed
          color="primary"
          @click="gerarGrafico(formData)"
          >Gerar gráfico</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      formData: {
        operadoras: [],
        data_referencia: null,
      },
      dateI: null,
      dateIFormatted: null,
      dtI: false,
      searchInput: null,
      showLine: false
    };
  },
  mounted() {
    this.dataList()
  },
  methods: {
    dataList() {
      let date = this.list? this.list.data_referencia : null
      this.dateIFormatted = date? moment(date).format("MM/YYYY"): null
      let operadoras = this.list && this.list.operadoras? this.list.operadoras: []
      this.formData.operadoras = !this.formData.operadoras.length? operadoras : this.formData.operadoras
    },
    parseDate(date) {
      if (!date) return null
      let [month, yar] = date.split("/") 
      return `${yar}-${month}-01`
    },
    toggleAll(campo, lista, allSelected) {
      let newList = [];
      this.$nextTick(() => {
        if (this[allSelected]) {
          this.formData[campo] = [];
        } else {
          this[lista]
          .forEach(function (item) {
            newList.push(item.id);
          });
          this.formData[campo] = newList;
        }
      });
    },
    toggleAutocomplete(item, campo) {
      let index = this.formData[campo].indexOf(item.id)
      //  index > -1  está excluindo a operadora
      if (index > -1) {
        this.formData[campo].splice(index, 1)
      } else {
      //  index < 0  está adicionando a operadora
        this.formData[campo].push(item.id)
      }
        this.$nextTick()
        return
    },
    // toggleOperadora(item) {
    //   this.searchInput = null
    //   let index = this.formData.operadoras.indexOf(item.id)
    //   //  index > -1  está excluindo a operadora
    //   if (index > -1) {
    //     this.formData.operadoras.splice(index, 1)
    //   } else {
    //     //  index < 0  está adicionando a operadora
    //       this.formData.operadoras.push(item.id)
    //   }
    //     this.$nextTick()
    //     return
    // },
  },
  watch: {
    dateI(val) {
      this.dateIFormatted = moment(val).format("MM/YYYY")
    },
    dateIFormatted(val) {
      this.formData.data_referencia = this.parseDate(val)
    },
    list() {
      this.dataList();
    }
  },
  props: {
    gerarGrafico: Function,
    list: Object,
    operadoras: Array
  },
};
</script>

<style>
</style>